import { createAction } from 'typesafe-actions';

import { ActionTypes as DiscoveryActions } from './constants';

interface GetBrowseDirectoryParams {
  directoryFeedType: $TSFixMe;
  directoryId: $TSFixMe;
  offset: $TSFixMe;
  path: $TSFixMe;
}

export const getBrowseDirectory = createAction(
  DiscoveryActions.GET_BROWSE_DIRECTORY,
  (params: GetBrowseDirectoryParams) => params,
)<GetBrowseDirectoryParams>();
export type GetBrowseDirectoryAction = ReturnType<typeof getBrowseDirectory>;

interface IngestBrowseDirectoryDataParams extends $TSFixMe {}

export const ingestBrowseDirectoryData = createAction(
  DiscoveryActions.INGEST_BROWSE_DIRECTORY_DATA,
  (params: IngestBrowseDirectoryDataParams) => params,
)<IngestBrowseDirectoryDataParams>();
export type IngestBrowseDirectoryDataAction = ReturnType<typeof ingestBrowseDirectoryData>;
